import React from 'react';
import { BAND_LABELS, EPC_COLORS, pickBand } from './buildingMetrics';

export const BAND_COLORS = {
  good: { text: '#3D6B38', bar: '#6BAF65' },
  fair: { text: '#B87430', bar: '#D4A257' },
  poor: { text: '#B85052', bar: '#C9696B' },
};

/** Coloured EPC grade tag. `compact` drops the "EPC" prefix (tables, legends). */
export const EPCBadge = ({ rating, compact = false }) => (
  <span
    className={[
      'inline-flex items-center justify-center h-6 px-2 rounded-[4px] text-[11px] font-semibold leading-none',
      compact ? 'min-w-[32px]' : 'min-w-[36px]',
    ].join(' ')}
    style={{ background: EPC_COLORS[rating] || '#7A8B77', color: '#ffffff' }}
  >
    {compact ? rating : `EPC ${rating}`}
  </span>
);

/** Performance score as a bar coloured by its band, with the percentage. */
export const PerformanceBar = ({ value }) => {
  if (value == null) return <span className="text-lb-muted">—</span>;
  const score = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <span className="inline-flex items-center gap-2.5">
      <span
        className="w-[88px] h-1.5 rounded-full overflow-hidden"
        style={{ background: 'rgba(20,20,20,0.07)' }}
        aria-hidden="true"
      >
        <span className="block h-full rounded-full" style={{ width: `${score}%`, background: BAND_COLORS[pickBand(score)].bar }} />
      </span>
      <span className="tabular-nums text-lb-ink w-9">{score}%</span>
    </span>
  );
};

/** "● Good · 86% performance" */
export const BandLabel = ({ score }) => {
  const band = pickBand(score);
  return (
    <span className="inline-flex items-center gap-1.5 text-[13px]" style={{ color: BAND_COLORS[band].text }}>
      <span className="w-2 h-2 rounded-full" style={{ background: BAND_COLORS[band].bar }} aria-hidden="true" />
      {BAND_LABELS[band]} · {score}% performance
    </span>
  );
};
